import classNames from 'classnames';
import { useState } from 'react';
import FlipSvg from 'public/images/svg_icons/flip.svg';

export const Tips: React.FC<{
  tips: { title: string; content: JSX.Element | string; tipCardColor: string | null }[];
  tipCardClass: string;
}> = ({ tips, tipCardClass }) => {
  const [tipIndex, setTipIndex] = useState<number | undefined>(undefined);

  return (
    <div className="tw-flex tw-items-start tw-overflow-x-auto custom-scrollbar">
      {tips.map((tip, index) => (
        <div key={tip.title} className="tw-min-h-xs">
          <div
            className={classNames(
              `tw-relative tw-cursor-pointer md:tw-p-7 tw-p-6 ${tip.tipCardColor}`,
              {
                'md:tw-w-64 tw-w-72 tw-h-96 tw-mr-7 tw-rounded-lg': !tipCardClass,
                [tipCardClass]: tipCardClass,
              }
            )}
            onClick={() => {
              setTipIndex(index === tipIndex ? undefined : index);
            }}
          >
            {tipIndex === index ? (
              <div className="tw-leading-tight">{tip.content}</div>
            ) : (
              <>
                <div className="tw-text-4xl tw-font-styleSans tw-font-semibold tw-leading-8">
                  {tip.title}
                </div>
                <div className="tw-absolute tw-bottom-6 tw-right-6 tw-text-right tw-cursor-pointer">
                  <FlipSvg className="tw-text-brand-navy tw-h-6 tw-w-6" />
                  <div className="tw-font-semibold tw-font-styleSans">Flip me!</div>
                </div>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
